import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useFeatureRegistration, type FeatureMeta } from '@/contexts/FeatureRegistryContext';
import { AskCannafaxPanel } from '@/components/ask-cannafax/AskCannafaxPanel';

export const FEATURE_META: FeatureMeta = {
  id: 'ask-cannafax-widget',
  label: 'Ask Cannafax (AI assistant)',
  description:
    'In-app AI assistant. Open via the orange Ask Cannafax button in the Desk ribbon (the header mark on phones), or Ctrl+K, to ask how-to questions, get page-aware guidance, or troubleshoot.',
  triggerType: 'panel',
  personas: ['seller', 'buyer_seller', 'buyer'],
};

/**
 * Thin wrapper: keeps the feature-registry contract stable while the
 * assistant UI lives in `components/ask-cannafax/`.
 */
const AskCannafaxWidget = () => {
  useFeatureRegistration(FEATURE_META);
  const { user } = useAuth();
  const { pathname } = useLocation();

  // Customer assistant only: never mounted inside the Admin Console.
  if (!user || /^\/admin(\/|$)/.test(pathname)) return null;
  return <AskCannafaxPanel />;
};

export default AskCannafaxWidget;
